import { useEffect } from 'react';
import { useStore } from 'react-redux';
import type { IMe, Lang } from '@platform/core/types';
import { applyColorScheme } from '@platform/core/lib/colorScheme';
import { i18n } from '@platform/i18n';
import { useAppDispatch } from '@platform/state/hooks';
import type { RootState } from '@platform/state/RootState';
import { colorSchemeChanged, langChanged } from '@platform/state/slices/sessionSlice';

const isLang = (value: string): value is Lang => value === 'uk' || value === 'en';

/**
 * Застосовує серверні налаштування користувача (locale і colorScheme з GET /me), коли вони відрізняються від сесії:
 * між пристроями джерело істини — сервер. Ефект реагує лише на зміну даних /me, тому локальна зміна у профілі
 * (яка одразу зберігається на сервері) не відкочується до завершення запиту.
 */
export function useServerPreferences(me: IMe | undefined): void {
  const dispatch = useAppDispatch();
  const store = useStore<RootState>();
  const locale = me?.locale;
  const scheme = me?.colorScheme;
  useEffect(() => {
    const session = store.getState().session;
    if (locale && isLang(locale) && locale !== session.lang) {
      dispatch(langChanged(locale));
      void i18n.changeLanguage(locale);
    }
    if (scheme && scheme !== session.colorScheme) {
      dispatch(colorSchemeChanged(scheme));
      applyColorScheme(scheme);
    }
  }, [locale, scheme, dispatch, store]);
}
